var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500244,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.748 50.4559H35.498L49.748 45.9559V45.3679C49.7475 44.7559 49.6035 44.1525 49.3275 43.6063C49.0516 43.06 48.6514 42.586 48.1591 42.2224C47.6669 41.8588 47.0962 41.6156 46.493 41.5125C45.8897 41.4093 45.2707 41.449 44.6855 41.6284L35.498 44.4559M35.498 44.4559H27.998M35.498 44.4559V39.9559L26.063 38.5039C25.4211 38.405 24.7654 38.4462 24.1409 38.6245C23.5163 38.8028 22.9377 39.1141 22.4448 39.537C21.9518 39.9598 21.5561 40.4843 21.2848 41.0744C21.0135 41.6646 20.8731 42.3064 20.873 42.9559",
    stroke: "#E64949",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4242 24.676L30.1582 28.9405L34.4242 33.2065",
    stroke: "#E64949",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.668 24.676L50.934 28.942L46.668 33.208",
    stroke: "#E64949",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5996 34.1298L42.4906 22.4553",
    stroke: "#E64949",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsDevelopment);
export default __webpack_public_path__ + "static/media/DevOps_Development.48809b1681213815da0ce0177b6ad61c.svg";
export { ForwardRef as ReactComponent };